export default function getResource(label, vars = []) {
    const resources = {
        title: 'Apply Rouge Rewards',
        apply: 'Apply',
        applied: 'Applied',
        remove: 'Remove',
        rougeRewardsSubText: `$${vars[0]} Rouge Reward`,
        rougeRewardsExpirationMessage: `Exp ${vars[0]}`,
        done: 'Done'
    };

    return resources[label];
}
